function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Space, Image, Alert, Select, Tag, Radio, Flex, notification } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { GlobeEuropeAfrica, TelephoneFill, LockFill, EnvelopeAtFill, PersonVcard, HSquareFill, PeopleFill, GeoAltFill } from "react-bootstrap-icons";
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Start = function Start() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    stepOnePassed = _useState2[0],
    setStepOnePassed = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    stepTwoPassed = _useState4[0],
    setStepTwoPassed = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    stepThreePassed = _useState6[0],
    setStepThreePassed = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isFormPrecessing = _useState8[0],
    setIsFormProcessing = _useState8[1];
  var _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    errorMessage = _useState0[0],
    setErrorMessage = _useState0[1];
  var _useState1 = useState(''),
    _useState10 = _slicedToArray(_useState1, 2),
    successMessage = _useState10[0],
    setSuccessMessage = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    countryList = _useState12[0],
    setCountryList = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    createdUser = _useState14[0],
    setCreatedUser = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    createdAccount = _useState16[0],
    setCreatedAccount = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    countryId = _useState18[0],
    setCountryId = _useState18[1];
  var _useState19 = useState(""),
    _useState20 = _slicedToArray(_useState19, 2),
    businessName = _useState20[0],
    setBusinessName = _useState20[1];
  var _useState21 = useState(""),
    _useState22 = _slicedToArray(_useState21, 2),
    businessAddress = _useState22[0],
    setBusinessAddress = _useState22[1];
  var _useState23 = useState(""),
    _useState24 = _slicedToArray(_useState23, 2),
    email = _useState24[0],
    setEmail = _useState24[1];
  var _useState25 = useState(5),
    _useState26 = _slicedToArray(_useState25, 2),
    maxUserCount = _useState26[0],
    setMaxUserCount = _useState26[1];
  var _useState27 = useState(''),
    _useState28 = _slicedToArray(_useState27, 2),
    maxUserCountDescription = _useState28[0],
    setMaxUserCountDescription = _useState28[1];
  var _useState29 = useState(null),
    _useState30 = _slicedToArray(_useState29, 2),
    newUserId = _useState30[0],
    setNewUserId = _useState30[1];
  var _useState31 = useState(""),
    _useState32 = _slicedToArray(_useState31, 2),
    firstname = _useState32[0],
    setFirstname = _useState32[1];
  var _useState33 = useState(""),
    _useState34 = _slicedToArray(_useState33, 2),
    lastname = _useState34[0],
    setLastname = _useState34[1];
  var _useState35 = useState(""),
    _useState36 = _slicedToArray(_useState35, 2),
    mobile = _useState36[0],
    setMobile = _useState36[1];
  var _useState37 = useState(""),
    _useState38 = _slicedToArray(_useState37, 2),
    password = _useState38[0],
    setPassWord = _useState38[1];
  var _useState39 = useState(false),
    _useState40 = _slicedToArray(_useState39, 2),
    isSmsSending = _useState40[0],
    setIsSmsSending = _useState40[1];
  var _useState41 = useState([]),
    _useState42 = _slicedToArray(_useState41, 2),
    plans = _useState42[0],
    setPlans = _useState42[1];
  var _useState43 = useState([]),
    _useState44 = _slicedToArray(_useState43, 2),
    pmList = _useState44[0],
    setPmList = _useState44[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    first_form = _Form$useForm2[0];
  var _Form$useForm3 = Form.useForm(),
    _Form$useForm4 = _slicedToArray(_Form$useForm3, 1),
    second_form = _Form$useForm4[0];
  var _Form$useForm5 = Form.useForm(),
    _Form$useForm6 = _slicedToArray(_Form$useForm5, 1),
    third_form = _Form$useForm6[0];
  var onFirstStepFinish = function onFirstStepFinish(values) {
    setCountryId(values.country_id);
    setBusinessName(values.business_label);
    setMaxUserCount(values.max_user_count);
    if (values.max_user_count == 5) setMaxUserCountDescription("Formule choisie: Basic 5 - 425 000 GNF/Mois");
    if (values.max_user_count == 25) setMaxUserCountDescription("Formule choisie: Standard 25 - 1 200 000 GNF/Mois");
    if (values.max_user_count == 50) setMaxUserCountDescription("Formule choisie: Pro 50 - 3 750 000 GNF/Mois");
    if (values.max_user_count == 51) setMaxUserCountDescription("Formule choisie: Business 50+ - Offre personnalisé");
    setBusinessAddress(values.business_address);
    setStepOnePassed(true);
  };
  var onSecondStepFinish = function onSecondStepFinish(values) {
    setIsFormProcessing(true);
    var fd = new FormData();
    fd.append("country_id", countryId);
    fd.append("firstname", values.firstname);
    fd.append("lastname", values.lastname);
    fd.append("email", values.email);
    fd.append("mobile", values.mobile);
    fd.append("business_label", businessName);
    fd.append("subscription_plan_id", values.subscription_plan_id);
    fd.append("business_address", businessAddress);
    fd.append("max_user_count", maxUserCount);
    fd.append("password", values.password);
    fd.append("password_confirmation", values.password_confirmation);
    setMobile(values.mobile);
    setFirstname(values.firstname);
    setLastname(values.lastname);
    setPassWord(values.password);
    axios.post(Common.baseApiUrl + "addaccount", fd).then(function (response) {
      if (response.data.status == 200 || response.data.status == 201) {
        setCreatedUser(response.data.user);
        setNewUserId(response.data.user.id);
        setCreatedAccount(response.data.account);
        if (response.data.status == 201) setErrorMessage(response.data.message);
        setStepTwoPassed(true);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue ...");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  var handlePlanChange = function handlePlanChange(v) {
    if (plans.filter(function (p) {
      return p.value == v.target.value;
    })[0].price - businessAccount.subscription_plan.monthly_price > 0) setTotalAmount(plans.filter(function (p) {
      return p.value == v.target.value;
    })[0].price - businessAccount.subscription_plan.monthly_price);else {
      setTotalAmount(0);
    }
  };
  var onThirdStepFinish = function onThirdStepFinish(values) {
    setIsFormProcessing(true);
    axios.post(Common.baseApiUrl + "confirmuserotp", {
      mobile: mobile,
      password: password,
      country_id: countryId,
      confirmation_code: values.confirmation_code
    }).then(function (response) {
      if (response.data.status == 200) {
        setStepThreePassed(true);
        localStorage.clear();
        localStorage.setItem('userData', JSON.stringify(response.data.user));
        localStorage.setItem('isOn', true);
        document.location = Common.baseUrl + "#/home/modules";
        document.title = "CliniqueAdmin | Bonjour";
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue ...");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {
    axios.get(Common.baseApiUrl + "getactivecountries").then(function (response) {
      if (response.data.status == 200) {
        response.data.countries.forEach(function (e) {
          setCountryList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: e.id,
              label: e.country_name + "(" + e.country_code + ")"
            }]);
          });
        });
        if (response.data.countries.length > 0) first_form.setFieldsValue({
          country_id: response.data.countries[0].id
        });
        setCountryId(response.data.countries[0].id);
      }
    })["catch"](function (error) {});
  }, []);
  useEffect(function () {
    if (countryId == null) return;
    axios.all([axios.get(Common.baseApiUrl + 'getpgs'), axios.get(Common.baseApiUrl + 'getsubscriptionplans/' + countryId.toString())]).then(function (response) {
      if (response[1].data.status == 200) {
        response[1].data.plans.forEach(function (e) {
          setPlans(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              price: e.monthly_price,
              value: e.id,
              label: /*#__PURE__*/_jsxs("div", {
                style: {
                  width: "100%",
                  marginBottom: "5px",
                  borderRadius: "7px",
                  padding: "8px",
                  border: "1px solid #E1DCC5"
                },
                gap: "small",
                justify: "center",
                align: "center",
                vertical: true,
                children: [/*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsx("div", {
                    children: /*#__PURE__*/_jsx("b", {
                      children: e.label
                    })
                  }), /*#__PURE__*/_jsxs(Tag, {
                    color: "#40714A",
                    children: [e.monthly_price.toLocaleString("Fr"), " GNF / Mois"]
                  })]
                }), /*#__PURE__*/_jsx("p", {
                  children: e.description
                })]
              })
            }]);
          });
        });
        if (response[1].data.plans.length > 0) {
          first_form.setFieldsValue({
            subscription_plan_id: response[1].data.plans[0].id
          });
        }
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue, verifiez votre connexion internet " + error.toString()
      });
    });
  }, [countryId]);
  useEffect(function () {
    first_form.setFieldsValue({
      max_user_count: maxUserCount,
      country_id: countryId,
      business_label: businessName,
      business_address: businessAddress,
      firstname: firstname,
      lastname: lastname,
      email: email,
      mobile: mobile
    });
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 5,
          sm: 12,
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
              minHeight: "700px",
              borderRadius: "6px",
              padding: "25px"
            },
            children: [stepOnePassed == false && stepTwoPassed == false && stepThreePassed == false && /*#__PURE__*/_jsxs(Form, {
              size: "large",
              form: first_form,
              onFinish: onFirstStepFinish,
              layout: "vertical",
              children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Alert, {
                  type: "error",
                  message: errorMessage,
                  showIcon: true
                })
              }), successMessage.length != 0 && /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Alert, {
                  type: "success",
                  message: successMessage,
                  showIcon: true
                })
              }), /*#__PURE__*/_jsxs("fieldset", {
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  name: "country_id",
                  label: "Pays",
                  rules: [{
                    required: true,
                    message: 'Ce champ est obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Select, {
                    options: countryList,
                    prefix: /*#__PURE__*/_jsx(GlobeEuropeAfrica, {
                      size: 18
                    })
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  name: "business_label",
                  label: "Nom de votre hopital, clinique, centre ...?",
                  rules: [{
                    required: true,
                    message: 'Ce champ est obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Input, {
                    prefix: /*#__PURE__*/_jsx(HSquareFill, {
                      size: 18
                    })
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  name: "business_address",
                  label: "Adresse",
                  rules: [{
                    required: true,
                    message: 'Ce champ est obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Input, {
                    prefix: /*#__PURE__*/_jsx(GeoAltFill, {
                      size: 18
                    })
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  size: "large",
                  label: "Choisir la formule souhait\xE9e",
                  name: "subscription_plan_id",
                  rules: [{
                    required: true,
                    message: "Ce champ est obligatoire"
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    style: {
                      width: "100%"
                    },
                    options: plans
                  })
                })]
              }), /*#__PURE__*/_jsx(Space, {
                direction: "horizontal",
                children: /*#__PURE__*/_jsx(Form.Item, {
                  children: /*#__PURE__*/_jsx(Button, {
                    loading: isFormPrecessing,
                    htmlType: "submit",
                    type: "primary",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "Continuer"
                    })
                  })
                })
              })]
            }), stepOnePassed == true && stepTwoPassed == false && stepThreePassed == false && /*#__PURE__*/_jsxs(Form, {
              form: second_form,
              onFinish: onSecondStepFinish,
              layout: "vertical",
              children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Alert, {
                  type: "error",
                  message: errorMessage,
                  showIcon: true
                })
              }), successMessage.length != 0 && /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Alert, {
                  type: "success",
                  message: successMessage,
                  showIcon: true
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Alert, {
                  message: maxUserCountDescription,
                  type: "info",
                  showIcon: true
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "firstname",
                label: "Pr\xE9nom",
                rules: [{
                  required: true,
                  message: 'Ce champ est obligatoire'
                }],
                children: /*#__PURE__*/_jsx(Input, {
                  prefix: /*#__PURE__*/_jsx(PersonVcard, {
                    size: 18
                  })
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "lastname",
                label: "Nom",
                rules: [{
                  required: true,
                  message: 'Ce champ est obligatoire'
                }],
                children: /*#__PURE__*/_jsx(Input, {
                  prefix: /*#__PURE__*/_jsx(PersonVcard, {
                    size: 18
                  })
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "email",
                label: "E-mail",
                rules: [{
                  required: true,
                  message: 'Ce champ est obligatoire'
                }],
                children: /*#__PURE__*/_jsx(Input, {
                  prefix: /*#__PURE__*/_jsx(EnvelopeAtFill, {
                    size: 18
                  })
                })
              }), /*#__PURE__*/_jsxs("fieldset", {
                children: [/*#__PURE__*/_jsx("legend", {
                  children: "Informations de connexion"
                }), /*#__PURE__*/_jsx(Form.Item, {
                  name: "mobile",
                  help: /*#__PURE__*/_jsx(Alert, {
                    type: "warning",
                    banner: true,
                    message: /*#__PURE__*/_jsx("b", {
                      children: "Ce num\xE9ro mobile sera votre identifiant administrateur. "
                    })
                  }),
                  label: "T\xE9l\xE9phone (Login)",
                  rules: [{
                    required: true,
                    message: 'Ce champ est obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Input, {
                    prefix: /*#__PURE__*/_jsx(TelephoneFill, {
                      size: 18
                    })
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  name: "password",
                  label: "Mot de passe",
                  rules: [{
                    required: true,
                    message: 'Ce champ est obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Input.Password, {})
                }), /*#__PURE__*/_jsx(Form.Item, {
                  name: "password_confirmation",
                  label: "Mot de passe (confirmation)",
                  rules: [{
                    required: true,
                    message: 'Ce champ est obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Input.Password, {})
                })]
              }), /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  children: /*#__PURE__*/_jsx(Button, {
                    type: "default",
                    onClick: function onClick() {
                      setStepOnePassed(false);
                      setStepTwoPassed(false);
                      setStepThreePassed(false);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "Retour"
                    })
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  children: /*#__PURE__*/_jsx(Button, {
                    loading: isFormPrecessing,
                    htmlType: "submit",
                    type: "primary",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "Confirmer le num\xE9ro"
                    })
                  })
                })]
              })]
            }), stepOnePassed == true && stepTwoPassed == true && stepThreePassed == false && /*#__PURE__*/_jsxs(Form, {
              size: "large",
              form: third_form,
              onFinish: onThirdStepFinish,
              layout: "vertical",
              children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Alert, {
                  type: "error",
                  message: errorMessage,
                  showIcon: true
                })
              }), successMessage.length != 0 && /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Alert, {
                  type: "success",
                  message: successMessage,
                  showIcon: true
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                style: {
                  textAlign: "center"
                },
                children: /*#__PURE__*/_jsx(Image, {
                  src: "/drawables/sms_c.png",
                  preview: false,
                  width: "160px"
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Alert, {
                  type: "warning",
                  banner: true,
                  message: /*#__PURE__*/_jsxs("b", {
                    children: ["Un code \xE0 \xE9t\xE9 envoy\xE9 au ", mobile.toString(), ". Veuillez Entrer le code puis cliquez sur CONFIRMER"]
                  })
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsxs("p", {
                  children: ["Vous n'avez pas le SMS?", /*#__PURE__*/_jsx(Button, {
                    loading: isSmsSending,
                    type: "link",
                    onClick: function onClick() {
                      setIsSmsSending(true);
                      axios.post(Common.baseApiUrl + "resendconfirmationsms", {
                        mobile: mobile.toString(),
                        country_id: countryId
                      }).then(function (response) {
                        if (response.data.status == 200) {
                          setErrorMessage("");
                          setSuccessMessage(response.data.message);
                        } else {
                          setSuccessMessage("");
                          setErrorMessage(response.data.message);
                        }
                      })["catch"](function (error) {
                        setSuccessMessage("");
                        setErrorMessage("Une erreur est survenue ");
                      })["finally"](function () {
                        setIsSmsSending(false);
                      });
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "Renvoyer"
                    })
                  })]
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "confirmation_code",
                rules: [{
                  required: true,
                  message: 'Ce champ est obligatoire'
                }],
                children: /*#__PURE__*/_jsx(Input, {
                  size: "large",
                  prefix: /*#__PURE__*/_jsx(LockFill, {
                    size: 18
                  })
                })
              }), /*#__PURE__*/_jsx(Space, {
                direction: "horizontal",
                children: /*#__PURE__*/_jsx(Form.Item, {
                  children: /*#__PURE__*/_jsx(Button, {
                    loading: isFormPrecessing,
                    htmlType: "submit",
                    type: "primary",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "Confirmer"
                    })
                  })
                })
              })]
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              textAlign: "center",
              padding: "18px"
            },
            children: [/*#__PURE__*/_jsx(Image, {
              preview: false,
              src: "/drawables/cl.png",
              width: "220px"
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("h2", {
                children: "Cr\xE9ez un compte maintenant !"
              }), /*#__PURE__*/_jsx("p", {
                children: "Profitez d'une p\xE9riode d'\xE9ssaie de sept (7) jours avec un acc\xE8s complet \xE0 tous vos modules ! Faites passer votre structure \xE0 un niveau sup\xE9rieur."
              })]
            })]
          })
        })]
      })
    })
  });
};
export default Start;